import env from 'core/env'
export const PAGE_SIZE = env('VITE_PAGE_SIZE', 10)
export const ACCESS_TOKEN = 'access-token'
export const REFRESH_TOKEN = 'refresh-token'
